export default {
  // Page-level
  'customize.title': '커스터마이징 & 견적',
  'customize.backToProduct': '상품으로 돌아가기',
  'customize.backToProductList': '상품 목록으로 돌아가기',
  'customize.loadingProduct': '상품 정보를 불러오는 중...',
  'customize.productNotFound': '상품을 찾을 수 없습니다',
  'customize.selectTargetHint': '좌측 상단에서<br />커스터마이징 대상을<br />선택해주세요.',
  'customize.sku': 'SKU',
  'customize.category': '카테고리',
  'customize.capacity': '용량',
  'customize.material': '재질',
  'customize.weight': '무게',
  'customize.processCount': '{{count}}개 프로세스',
  'customize.orderQuantity': '주문 수량',
  'customize.sampleQuantity': '샘플 수량',
  'customize.samplePurchase': '샘플구매',
  'customize.unit': '개',
  'customize.addProcessTitle': '후가공 프로세스 추가하기',
  'customize.addProcessDesc': '좌측 트리 메뉴에서 원하는 커스터마이징 옵션을 클릭하면 이곳에 프로세스가 추가됩니다.',
  'customize.processStep': '프로세스 {{index}}',
  'customize.finalStep': '최종 단계',
  'customize.cancel': '취소',
  'customize.printQuote': '견적서 출력',
  'customize.previewTitle': '견적 미리보기',
  'customize.calculating': '견적 금액을 계산하는 중...',
  'customize.currency': '통화',
  'customize.appliedFx': '적용 환율',
  'customize.quantityLabel': '수량: {{count}}개',
  'customize.itemTotal': '품목 합계',
  'customize.productSubtotalUsd': '제품 소계 (USD)',
  'customize.finishingSubtotalUsd': '후가공 소계 (USD)',
  'customize.totalQuoteAmount': '총 견적 금액',
  'customize.close': '닫기',
  'customize.processing': '처리 중...',
  'customize.requestQuote': '견적 요청하기',

  // Errors
  'customize.error.loadingProduct': '상품 정보를 불러오는 중입니다.',
  'customize.error.loadingFinishing': '후가공 견적 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.',
  'customize.error.finishingMapping': '선택한 후가공의 견적 정보를 확인할 수 없습니다. 잠시 후 다시 시도해주세요.',
  'customize.error.preview': '견적 미리보기 요청 중 오류가 발생했습니다.',
  'customize.error.create': '견적 생성 중 오류가 발생했습니다.',

  // Tree
  'customize.tree.title': '커스터마이징 옵션',
  'customize.tree.loginRequired': '로그인 후 후가공 옵션을 이용할 수 있어요',
  'customize.tree.partsReplace': '부속품 교체 (CAP & PUMP)',
  'customize.tree.finishingColor': '후가공 및 색상변경',
  'customize.tree.printingAdd': '후가공 인쇄 추가',

  // Shared finishing selection labels
  'customize.selectPart': '부위 선택',
  'customize.selectMethod': '후가공 방법',
  'customize.selectColor': '색상 선택',
  'customize.selected': '선택 완료',
  'customize.methodsCount': '{{count}}가지 방법',
  'customize.selectPartFirst': '- 부위를 먼저 선택하세요',
  'customize.selectPartHint': '왼쪽에서 부위를 선택하면<br />적용 가능한 후가공 방법이 표시됩니다.',
  'customize.selectMethodFirst': '- 방법을 먼저 선택하세요',
  'customize.confirmHint': '- 확인 버튼을 눌러주세요',
  'customize.selectMethodHint': '중앙에서 후가공 방법을 선택하면<br />색상을 지정할 수 있습니다.',
  'customize.popularColors': '인기 컬러',
  'customize.premium': 'Premium',
  'customize.customInput': '직접 입력',
  'customize.changeColor': '색상 변경',
  'customize.changeColorHint': '색상을 변경하거나 다른 후가공 방법을 선택할 수 있습니다.',
  'customize.reselect': '다시선택',
  'customize.confirm': '조건확정',
  'customize.resetAll': '전체 초기화',
  'customize.pantoneCode': 'Pantone 코드',
  'customize.noPantone': 'Pantone 미지정',
  'customize.selectThisColor': '이 색상으로 선택',
  'customize.selectColorButton': '이 색상 선택',
  'customize.done': '완료',
  'customize.edit': '수정하기',
  'customize.removeProcess': '이 프로세스 제거',
  'customize.confirmedMessage': '아래 내용으로 선택이 완료되었습니다.',
  'customize.selectedConditions': '선택조건({{count}}건):',
  'customize.metallic': '메탈릭',
  'customize.pearl': '펄',
  'customize.softTouch': '소프트터치',
  'customize.pantoneRequired': 'Pantone 코드를 입력해주세요.',
  'customize.hexInvalid': '올바른 HEX 색상 코드를 입력해주세요. (예: #FF6B6B)',
  'customize.customColorHint': 'Pantone 번호와 색상을 직접 입력하세요.',
  'customize.keepExistingColor': '기존 색상 유지',
  'customize.colorPlaceholder': '예: Pantone 185 C',

  // Shared AI progress / result
  'customize.progressLabel': '진행율 (예상소요시간 1분-1분30초)',
  'customize.aiGeneratedImage': 'AI 생성이미지',
  'customize.generatedCheck': '생성된 이미지를 확인하세요',
  'customize.imageLoadError': '이미지를 불러올 수 없습니다',
  'customize.regenerate': '다시 생성하기',
  'customize.viewLarge': '크게 보기',
  'customize.download': '다운로드',
  'customize.aiGenerateAgain': '다시 생성',
  'customize.generateFailed': '생성 실패',
  'customize.retry': '다시 시도',
  'customize.aiImageInfo': 'AI 생성 이미지 안내',
  'customize.aiImageInfo1': '본 이미지는 고객님의 디자인 및 후가공 적용 모습을 이해하기 쉽도록 AI 기술을 활용해 제작한 참고용 예상 이미지입니다.',
  'customize.aiImageInfo2': 'AI 생성 이미지는 형태, 크기, 색상, 재질, 투명도, 광택, 인쇄 위치, 인쇄 범위 및 후가공 효과 등이 실제 생산품과 다르게 표현될 수 있습니다.',
  'customize.aiImageInfo3': '실제 생산은 용기 도면, 인쇄 가능 범위, 원본 디자인 파일, 색상 기준, 후가공 방식 및 생산 조건을 확인한 후 진행되며, 고객님의 최종 시안 승인 이후 제작됩니다.',

  // Parts replace
  'customize.parts.selectPart': '교체할 부속품을 선택하세요',
  'customize.parts.selectHint': '선택 시<br />표시',
  'customize.parts.loading': '호환 부속품을 불러오는 중...',
  'customize.parts.empty': '조건에 맞는 부속품이 없읍니다',
  'customize.parts.aiPreview': 'AI 부품조립 미리보기',
  'customize.parts.aiUnavailable': 'AI 처리 불가',
  'customize.parts.confirmBeforeStart': '시작하기 전에 확인해주세요',
  'customize.parts.currentlyUnavailable': '현재 이용하실 수 없습니다',
  'customize.parts.aiNotice': '이 작업은 AI 를 통해 진행되는 작업입니다. 인터넷의 속도에 따라서 1분 -5분까지 처리시간이 소요 될 수 있습니다.',
  'customize.parts.resourceNotice': '죄송합니다. AI 처리에 필요한 리소스가 부족합니다',
  'customize.parts.start': '시작',
  'customize.parts.confirm': '확인',
  'customize.parts.resultCount': '{{count}}개 결과 생성됨',
  'customize.parts.failed': '(실패)',
  'customize.parts.assemblyResult': '조립 결과',

  // Finishing
  'customize.finishing.selectDesc': '부위 → 후가공 방법 → 색상 순서로 선택해주세요. 여러 부위를 각각 다르게 지정할 수 있습니다.',
  'customize.finishingOnly.selectDesc': '부위 → 후가공 방법 순서로 선택해주세요. 색상은 기존 그대로 유지됩니다. 여러 부위를 각각 다르게 지정할 수 있습니다.',
  'customize.finishing.aiGenerate': 'AI 후가공생성',
  'customize.finishing.aiPreview': 'AI 후가공 미리보기',
  'customize.finishing.aiPreviewComplete': 'AI 미리보기 완료',
  'customize.finishing.workingImage': '작업 기준 이미지',
  'customize.finishing.aiResult': 'AI 생성 결과',
  'customize.finishing.resultTitle': 'AI 후가공 결과',

  // Color only
  'customize.color.selectHint': '변경할 색상을 선택해주세요. 인기 컬러, Premium, 또는 직접 입력이 가능합니다.',

  // Printing
  'customize.print.position': '인쇄 위치',
  'customize.print.positionPlaceholder': '인쇄 위치를 선택하세요',
  'customize.print.method': '인쇄 방식 선택',
  'customize.print.methodPlaceholder': '인쇄 방식을 선택하세요',
  'customize.print.autoSet': '자동설정',
  'customize.print.photoTransfer': '사진전사',
  'customize.print.uploadDesign': '디자인 파일 올리기',
  'customize.print.removeFile': '파일 제거',
  'customize.print.upload': '파일업로드',
  'customize.print.allowedFormat': '허용 규격: JPG, PNG, WebP',
  'customize.print.maxSize': '최대 10MB / 가로·세로 300px 이상 / 긴 변 2,048px 이하',
  'customize.print.ratio': '비율 1:2.5 ~ 2.5:1',
  'customize.print.aiPreview': 'AI 이미지 미리보기',
  'customize.print.noDesignFile': '디자인 파일 없음',
  'customize.print.positionUnset': '위치 미지정',
  'customize.print.uploadingArtwork': '아트워크 업로드 중...',
  'customize.print.creatingJob': '인쇄 미리보기 작업 생성 중...',
  'customize.print.uploadFailed': '파일 업로드 실패: {{message}}',
  'customize.print.noWorkingImage': '용기 working 이미지가 없습니다. 제품 이미지를 먼저 확인해주세요.',
  'customize.print.generateFailed': '인쇄 미리보기 생성에 실패했습니다.',
  'customize.print.statusError': '상태 확인 중 오류 발생',
  'customize.print.unknownError': '알 수 없는 오류가 발생했습니다.',
  'customize.print.invalidFile': '알 수 없는 오류로 파일을 사용할 수 없습니다.',
  'customize.print.capTopTitle': 'CAP 상단면 인쇄 안내',
  'customize.print.capTopSubtitle': '이미지 업로드 시 유의사항',
  'customize.print.capTopBody': 'CAP 상단면 인쇄시에는 별도로 CAP의 상단면이 정면으로 보이는 이미지를 올려야 합니다',
  'customize.print.capTopHint': '용기 측면 사진이 아닌, CAP의 윗면(탑뷰)을 정면에서 촬영한 별도 이미지를 준비해 주세요. 측면 이미지만으로는 상단 인쇄 영역을 정확히 확인할 수 없습니다.',
  'customize.print.understood': '확인했습니다',
  'customize.print.uploadedFileAlt': '업로드된 디자인 파일',
  'customize.printing.resultTitle': 'AI 인쇄 미리보기 결과',

  // Printing positions
  'customize.printPosition.bodyFront': 'Body 전면',
  'customize.printPosition.middleRing': '중간테두리',
  'customize.printPosition.capSide': 'CAP 측면',
  'customize.printPosition.capTop': 'CAP 상단면',
};